import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { getProducts } from "../../utils/storage";

// import CartToast from "../components/CartToast";

import "../styles/ShopByBrandStyles.css";

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

/* ── Catalogue record → the flat shape this page and the detail view read ── */
const toCard = (p) => ({
  id: p.id,
  title: p.name,
  brand: p.brand,
  badge: p.badge,
  price: inr(p.salePrice),
  oldPrice: p.mrp > p.salePrice ? inr(p.mrp) : "",
  stock: p.availability || "In Stock",
  image: p.images?.[0],
});

export default function ShopByBrand() {
  const { brand } = useParams();
  const navigate = useNavigate();
  const cardRefs = useRef([]);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    setProducts(
      getProducts()
        .filter((p) => p.isActive !== false)
        .map(toCard)
    );
  }, []);

  /* ── TOAST ── */
  // const [toast, setToast] = useState({ visible: false, message: "", type: "success" });

  // const showToast = (message, type = "success") => {
  //   setToast({ visible: true, message, type });
  //   setTimeout(() => setToast((prev) => ({ ...prev, visible: false })), 2800);
  // };

  /* ── FILTER PRODUCTS ── */
  const filteredProducts = useMemo(() => {
    if (!brand) return products;
    const wanted = decodeURIComponent(brand).toLowerCase();
    return products.filter((p) => p.brand?.toLowerCase() === wanted);
  }, [brand, products]);

  /* ── INTERSECTION OBSERVER — entrance animation ── */
  useEffect(() => {
    const observers = cardRefs.current.map((el, i) => {
      if (!el) return null;
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setTimeout(() => el.classList.add("sbb-visible"), i * 90);
            obs.disconnect();
          }
        },
        { threshold: 0.1 }
      );
      obs.observe(el);
      return obs;
    });
    return () => observers.forEach((o) => o?.disconnect());
  }, [filteredProducts]);

  /* ── ADD TO CART ── */
  // const addToCart = (product) => {
  //   const cart = JSON.parse(localStorage.getItem("cart")) || [];
  //   const existing = cart.find((item) => item.title === product.title);

  //   if (existing) {
  //     showToast("Item already been added to cart!", "warning");
  //     return true;
  //   }

  //   const numericPrice = Number(product.price.replace(/[₹Rs.,\s]/g, ""));
  //   cart.push({ title: product.title, image: product.image, price: numericPrice, qty: 1 });
  //   localStorage.setItem("cart", JSON.stringify(cart));
  //   window.dispatchEvent(new Event("cartUpdated"));
  //   showToast("Added to cart successfully", "success");
  //   return false;
  // };

  const pageTitle = brand ? decodeURIComponent(brand) : "Shop By Brand";

  return (
    <div className="sbb-root">

      {/* ── HERO ── */}
      <div className="sbb-hero">
        <div className="sbb-hero-inner">
          <span className="sbb-hero-eyebrow">Product Catalogue</span>
          <h1 className="sbb-hero-title">{pageTitle}</h1>
          <p className="sbb-hero-sub">
            Genuine products. Verified brands. Pan-India delivery.
          </p>
          <div className="sbb-hero-count">
            {filteredProducts.length} product{filteredProducts.length !== 1 ? "s" : ""} found
          </div>
        </div>
      </div>

      {/* ── BODY ── */}
      <div className="sbb-body">

        {/* GRID */}
        <div className="sbb-grid">
          {filteredProducts.map((product, i) => (
            <div
              key={product.id}
              className="sbb-card"
              ref={(el) => (cardRefs.current[i] = el)}
              onClick={() =>
                navigate(`/shop-by-brand/product/${product.id}`, { state: product })
              }
            >
              {/* Badge — top left */}
              <div className="sbb-card-badge">{product.badge}</div>

              {/* Quick action — top right, slides in on hover */}
              <div className="sbb-card-quick">
                <button
                  className="sbb-quick-btn"
                  title="View product"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/shop-by-brand/product/${product.id}`, { state: product });
                  }}
                >
                  <i className="ri-eye-line" />
                </button>
              </div>

              {/* Image area */}
              <div className="sbb-card-img-wrap">
                <img src={product.image} alt={product.title} className="sbb-card-img" />
              </div>

              {/* Body */}
              <div className="sbb-card-body">
                <div className="sbb-card-brand">{product.brand}</div>
                <h3 className="sbb-card-title">{product.title}</h3>
                <div className="sbb-card-stock">
                  <div className="sbb-stock-dot" />
                  {product.stock} · Fast Shipping
                </div>
              </div>

              {/* Footer — single CTA slides up on hover */}
              <div className="sbb-card-footer">
                <button
                  className="sbb-cta"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/shop-by-brand/product/${product.id}`, { state: product });
                  }}
                >
                  <i className="ri-eye-line" />
                  View Product
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Empty state */}
        {filteredProducts.length === 0 && (
          <div className="sbb-empty">
            <p>
              We stock <strong>{pageTitle}</strong> to order — nothing is listed
              online yet.
            </p>
            <p>
              Call us for availability and pricing, or browse the full range.
            </p>
            <button
              className="sbb-empty-cta"
              onClick={() => navigate("/products")}
            >
              <i className="ri-grid-line" />
              Browse All Products
            </button>
          </div>
        )}
      </div>

      {/* Toast */}
      {/* <CartToast visible={toast.visible} message={toast.message} type={toast.type} /> */}
    </div>
  );
}